<template>
	<tr class="table__main"
		draggable="true"
		@dragstart="startDrag($event, file.id)"
		:class="selected ? 'selected' : ''"
		@click="oneClick"
		v-bind="$attrs"
	>
		<td class="table__cell table__cell--center">
			<img class="table__icon" :src="getFileLogo(file.name)" :alt="getFileTypeName(file.name)" /></td>
		<td>
			<span class="table__name">{{ file.name }}</span>
			<br />
			<!-- <span class="table__description">{{ file.description }}</span> -->
			<span class="table__description">{{ getDate(file.uploaded_at) }}</span>
			<button 
				class="table__button button button--secondary button--small" 
				@click.stop="downloadFile()"
			>
				Télécharger
			</button>
		</td>	
		<td>
			<img
				@click="onClickShareStudent()"
				class="table__share"
				:src="isSharedWithStudents ? '/img/share-line.svg' : '/img/share.svg'"
				alt="type"
			/>
		</td>
		<td>
			<img
				@click="onClickShareTeacher()"
				class="table__share" 
				:src="isSharedWithTeachers ? '/img/share.svg' : '/img/share-line.svg'" 
				alt="type"
			/>
		</td>
		<td><img class="table__options" @click="isPopUpVisible = !isPopUpVisible" :src='`/img/three-dots.png`' alt="type" /> </td>
	</tr>
	<Teleport to="body">
		<pop-up-menu-file
			v-if="isPopUpVisible"
			:x="x"
			:y="y"
			@close="isPopUpVisible = !isPopUpVisible"
			@remove="removeFile"
			@showPopUpEditFile="
				isPopUpEditFileVisible = !isPopUpEditFileVisible
			"
			:file="newFile"
		/>
	</Teleport>
	<Teleport to="body">
		<pop-up-edit-file
			v-if="isPopUpEditFileVisible"
			@close="isPopUpEditFileVisible = !isPopUpEditFileVisible"
			:file="newFile"
			@getFiles="changeFileName"
		/>
	</Teleport>
	<Teleport to="body">
		<pop-up-preview-file
			v-if="isPopUpPreviewFileVisible"
			@close="isPopUpPreviewFileVisible = !isPopUpPreviewFileVisible"
			:file="newFile"
		/>
	</Teleport>
	<!-- Popup partage aux étudiants -->
	<Teleport to="body">
		<PopUpShareFile
			v-if="showShareFile"
			type="file"
			:id="newFile.id"
			:sharedStudentIds="newFile.shared_with_students"
			@close="showShareFile = !showShareFile"
			@update:shared_with_students="updateSharedStudents"
		/>
	</Teleport>
	<!-- Popup partage aux professeurs -->
	<Teleport to="body">
		<PopUpSharePlaceFile
			v-if="showShareTeacher"
			type="file"
			:id="newFile.id"
			:classId="parseInt($route.params.id)"
			:sharedWithSpecificTeachers="newFile.shared_with_specific_teachers || []"
			:fileData="newFile"
			@close="showShareTeacher = false"
			@submit="handleTeacherShare"
			@stopShare="handleStopTeacherShare"
		/>
	</Teleport>
</template>

<script>
import { deleteFileService, updateFileService } from '../../../../services/filesService'
import { downloadMedia } from '../../../../services/mediaService'
import { getFileLogo, getFileTypeName } from '../../../../utils/fileTypes'
import PopUpEditFile from '../../../PopUp/Class/PopUpEditFile.vue'
import PopUpMenuFile from '../../../PopUp/Class/PopUpMenuFile.vue'
import PopUpPreviewFile from '../../../PopUp/Class/PopUpPreviewFile.vue'
import PopUpShareFile from '../../../PopUp/PopUpShareFile.vue'
import PopUpSharePlaceFile from '../../../PopUp/PopUpSharePlaceFile.vue'

export default {
  components: {
	PopUpMenuFile,
	PopUpEditFile,
	PopUpPreviewFile,
	PopUpShareFile,
	PopUpSharePlaceFile,
  },
	props: {
		file: Object,
		selected: Boolean,
		id: Number,
		selectedFile: Number
	},
	data() {
	return {
		showShareFile: false,
		showShareTeacher: false,
		newFile: {},
		isPopUpVisible: false,
		isPopUpEditFileVisible: false,
		isPopUpPreviewFileVisible: false,
		x: null,
		y: null,
		delay: 700,
		clicks: 0,
		}
	},
	computed:{
		initials(){
			return `${this.newFile.teacher.first_name[0]}${this.newFile.teacher.last_name[0]}`
		},
		isSharedWithStudents(){
			return this.newFile.shared_with_students.length === 0
		},
		isSharedWithTeachers(){
			return this.newFile.shared_with_teachers
		}
	},
	methods: {
		getFileLogo(filename) {
			return getFileLogo(filename)
		},
		getFileTypeName(filename) {
			return getFileTypeName(filename)
		},
		updateSharedStudents(newList) {
			this.newFile.shared_with_students = newList
		},
		onClickShareStudent(){
			this.showShareFile = true
		},
		onClickShareTeacher(){
			this.showShareTeacher = true
		},
		// Gère la soumission du partage aux professeurs
		handleTeacherShare(shareData) {
			console.log(shareData)
			const payload = {
				shared_with_teachers: true,
				subject: shareData.subject,
				chapter: shareData.chapter,
				is_public: shareData.is_public,
				shared_teacher_emails: shareData.shared_with_specific_teachers
			}
			
			updateFileService(this.newFile.id, payload)
			.then(() => {
				this.newFile.shared_with_teachers = true
				this.newFile.shared_with_specific_teachers = shareData.shared_with_specific_teachers
				this.newFile.is_public = shareData.is_public
				this.$store.state.toast = {
					status: 'success',
					text: 'Partage mis à jour',
				}
			})
			.catch(() => {
				this.$store.state.toast = {
					status: 'error',
					text: 'Erreur lors du partage',
				}
			})
		},
		// Gère l'arrêt du partage aux professeurs
		handleStopTeacherShare() {
			const payload = {
				shared_with_teachers: false
			}
			
			updateFileService(this.newFile.id, payload)
			.then(() => {
				this.newFile.shared_with_teachers = false
				this.$store.state.toast = {
					status: 'success',
					text: 'Partage arrêté',
				}
			})
			.catch(() => {
				this.$store.state.toast = {
					status: 'error',
					text: 'Erreur lors de l\'arrêt du partage',
				}
			})
		},
		oneClick() {
			this.clicks++
			this.$emit('select', this.file.id)
			if (this.clicks === 1) {
				this.timer = setTimeout(() => {
					this.clicks = 0
				}, this.delay)
			} else {
				clearTimeout(this.timer)
				let regex = /(?:\.([^.]+))?$/
				const extensions = ['png', 'jpg', 'gif']
				if (extensions.includes(regex.exec(this.file.file_upload)[1])) {
					let routeData = this.$router.resolve({ name: 'ShowImg', params: { fileName: this.file.file_upload } })
					window.open(routeData.href, '_blank')
				}
				else {
					this.isPopUpPreviewFileVisible = !this.isPopUpPreviewFileVisible

				}
				this.clicks = 0
			}
		},
		startDrag(evt, item) {
			evt.dataTransfer.dropEffect = 'move'
			evt.dataTransfer.effectAllowed = 'move'
			evt.dataTransfer.setData('itemID', item)
		},
		changeFileName(e) {
			this.newFile.name = e
		},
		getDate(e) {
			return e.slice(0, 10)
		},
		async downloadFile() {
			try {
				await downloadMedia(this.file.file_upload, this.newFile.name);
				
				this.$store.state.toast = {
					status: 'success',
					text: 'Fichier téléchargé avec succès',
				}
			} catch (error) {
				console.error('Erreur lors du téléchargement:', error)
				this.$store.state.toast = {
					status: 'error',
					text: 'Erreur lors du téléchargement du fichier',
				}
			}
		},
		removeFile(e) {
			this.$emit('remove', e)
		},
		deleteFile: async function () {
			let result = confirm('Etes vous sur de vouloir supprimer ?')
			if (result) {
				await deleteFileService(this.id)
				this.$emit('remove', this.id)
				this.newFile = {}
			}
		},
	},

	created() {
		this.newFile = this.file
		window.addEventListener('mousemove', (e) => {
			this.x = e.clientX
			this.y = e.clientY
		})
	},
}

</script>

<style>
</style>
